import { billingClient } from '../../billing-api-integration/client';
import { GraphQLQuery } from '@aws-amplify/api';
import { listEnabledBillingProviders, getBillingProvider } from './queries';
import { notifyError, showSuccessNotification } from '../../../../components/ServiceNotifications';
import { ListEnabledBillingProvidersResponse, GetBillingProviderResponse, BillingProvider } from '../types';

export const fetchEnabledBillingProviders = async (): Promise<BillingProvider[]> => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<ListEnabledBillingProvidersResponse>>({
            query: listEnabledBillingProviders
        });
        return response.data?.listEnabledBillingProviders?.items || [];
    } catch (e) {
        console.trace(e);
        notifyError(e);
        return [];
    }
};

export const fetchBillingProvider = async (id: string): Promise<BillingProvider | undefined> => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<GetBillingProviderResponse>>({
            query: getBillingProvider,
            variables: { id }
        });
        return response.data?.getBillingProvider;
    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const updateBillingProvider = async (id: string, input: any) => {
    try {
        const updateMutation = `
            mutation updateBillingProvider($input: UpdateBillingProviderInput!) {
                updateBillingProvider(input: $input) {
                    id
                    name
                    key
                    status
                }
            }
        `;
        const response = await billingClient.graphql<GraphQLQuery<any>>({
            query: updateMutation,
            variables: { input: { id, ...input } }
        });
        showSuccessNotification('Provider updated successfully');
        return response.data?.updateBillingProvider;
    } catch (e) {
        console.trace(e);
        notifyError(e);
        throw e;
    }
};

export const enableBillingProviderForCurrentCustomer = async (billingProviderId: string) => {
    try {
        const mutation = `
            mutation enableBillingProviderForCurrentCustomer($billingProviderId: ID!) {
                enableBillingProviderForCurrentCustomer(billingProviderId: $billingProviderId) {
                    id
                    entityType
                    localEntityId
                    billingProviderId
                    providerEntityId
                    syncStatus
                }
            }
        `;
        const response = await billingClient.graphql<GraphQLQuery<any>>({
            query: mutation,
            variables: { billingProviderId }
        });
        showSuccessNotification('Provider enabled successfully');
        return response.data?.enableBillingProviderForCurrentCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e);
        throw e;
    }
};

export const disableBillingProviderForCurrentCustomer = async (billingProviderId: string) => {
    try {
        const mutation = `
            mutation disableBillingProviderForCurrentCustomer($billingProviderId: ID!) {
                disableBillingProviderForCurrentCustomer(billingProviderId: $billingProviderId) {
                    id
                }
            }
        `;
        const response = await billingClient.graphql<GraphQLQuery<any>>({
            query: mutation,
            variables: { billingProviderId }
        });
        showSuccessNotification('Provider disabled successfully');
        return response.data?.disableBillingProviderForCurrentCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e);
        throw e;
    }
};
